'use client'
import React, { ComponentType, useEffect, useState } from 'react'
import Button from 'components/ui/basic/Button'
import { Tournament } from 'types'
import { Spinner } from 'components/ui/basic/Spinner'
import { useRouter } from 'next/navigation'
import {
  loginPath,
  myProfilePath,
  tournamentSchedulePath
} from 'shared/urlHelpers'
import { useSession } from 'lib/session-client'
import { Trash2 } from 'react-feather'
import { addMyTournament, canAddMyTournament } from '../../api/myTournament'
import FavoriteIcon from 'public/img/ci-icons/favoriten.svg'

type MyTournamentButtonProps = {
  tournament: Tournament
}

export const MyTournamentButton: ComponentType<MyTournamentButtonProps> = ({
  tournament
}) => {
  const [submitting, setSubmitting] = useState(false)
  const [canAdd, setCanAdd] = useState(true)
  const [session] = useSession()
  const router = useRouter()

  useEffect(() => {
    if (session) {
      canAddMyTournament(tournament.id, session.accessToken).then((res) => {
        setCanAdd(res)
      })
    }
  }, [session])

  const handleOnClick = () => {
    if (session && canAdd) {
      setSubmitting(true)
      addMyTournament(tournament.id, session.accessToken).then((d) => {
        setSubmitting(false)
        setCanAdd(false)
      })
    } else if (session && !canAdd) {
      router.push(myProfilePath())
    } else {
      router.push(loginPath({ backTo: tournamentSchedulePath(tournament) }))
    }
  }

  return (
    <Button
      iconOnly
      small
      onClick={handleOnClick}
      color={canAdd ? 'primary' : 'gray'}
      tooltip={
        canAdd ? 'Zu „Meine Ligen“ hinzufügen' : 'Von „Meine Ligen“ entfernen'
      }
    >
      {submitting && <Spinner loading={true} />}
      {!submitting && canAdd && <FavoriteIcon />}
      {!submitting && !canAdd && <Trash2 />}
    </Button>
  )
}
